module.exports = {"520325001":"道真仡佬族苗族自治县尹珍街道","520325100":"玉溪镇","520325101":"三江镇","520325102":"隆兴镇","520325103":"旧城镇","520325104":"忠信镇","520325105":"洛龙镇","520325106":"阳溪镇","520325107":"三桥镇","520325108":"大磏镇","520325109":"平模镇","520325110":"河口镇","520325200":"上坝土家族乡","520325201":"棕坪乡","520325202":"桃源乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520325.json
// module id = 2602
// module chunks = 0